<span class="xom-button-wrapper uicontrol"><ng-content></ng-content></span>
